// Belge listesi etiketi — tek kaynak. K6: "Taslak Word (ön izleme)" tip `partial` taşır ama
// nihai/kısmi rapordan AYRI görünür ("Taslak" rozeti); mevcut `partial` etiketi değişmez.
import type { DocumentInfo } from "@mahir/shared";

export const DRAFT_PREVIEW_BADGE = "Taslak";

export function documentTypeLabel(d: Pick<DocumentInfo, "type" | "isDraft">): string {
  if (d.type === "partial" && d.isDraft === true) return "Taslak Word (ön izleme)";
  if (d.type === "full") return "Tam Rapor";
  if (d.type === "partial") return "Kısmi Rapor";
  return "Form Taslağı";
}

export function isDraftPreview(d: Pick<DocumentInfo, "type" | "isDraft">): boolean {
  return d.type === "partial" && d.isDraft === true;
}
